import { Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth-guard.service";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { LoginComponent } from "./login/login.component";

export const AppRoutes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    children: [
      {
        path: "",
        loadChildren: "./login/login.module#LoginModule",
      },
    ],
  },
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./layouts/admin-layout/admin-layout.module").then(
            (m) => m.AdminLayoutModule
          ),
      },
    ],
  },
  // {
  //   path: 'sign-up',
  //   component: SignUpComponent
  // },
  // {
  //   path: 'sign-up/account-setting',
  //   component: AccountSettingComponent
  // },
  // {
  //   path: 'payment',
  //   component : PaymentComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: './payment/payment.module#PaymentModule'
  //     }
  //   ],
  // },
  {
    path: "**",
    redirectTo: "login",
  },
];
